module.exports = __webpack_public_path__ + "img/key.463d7e5c.png";